export default __webpack_public_path__ + "static/media/level-gps.7afdd8d3.png";